import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GridComponent } from 'src/app/components/grid/grid.component';
import { KullaniciTalep } from 'src/app/models/kullaniciTalep.model';
import { NebisTalepBilgiler } from 'src/app/models/nebisTalep.model';
import { GirisService } from 'src/app/services/giris.service';
import { KullaniciTalepService } from 'src/app/services/kullanici-talep.service';
import { YetkiService } from 'src/app/services/yetki.service';

declare var bootstrap: any;

@Component({
  selector: 'kullanici-talep-bilgi',
  templateUrl: './kullanici-talep-bilgi.component.html',
  styleUrls: ['./kullanici-talep-bilgi.component.css'],

})
export class KullaniciTalepBilgiComponent implements OnInit {

  constructor(private kullaniciTalepService: KullaniciTalepService, private yetkiService: YetkiService, private girisService: GirisService, private router: Router) { this.service = kullaniciTalepService }
  talepSay:number= -1;
  siliniyor = false;


  ngOnInit(): void {

  }

  kullaniciTalep: KullaniciTalep[] = [];
  kullaniciTalepNebis: NebisTalepBilgiler[] = [];
  service: KullaniciTalepService;
  @ViewChild('grid') grid?: GridComponent;



  sil(model: NebisTalepBilgiler) {
    this.siliniyor = true;
    this.kullaniciTalepService.delete(model).subscribe(response => {
      bootstrap.Modal.getInstance(document.getElementById('sil_modal')).hide();
      this.grid?.load();
      this.yetkiService.success("Talep başarıyla silindi.", 1)
      this.siliniyor = false;
    }, error => {
      this.yetkiService.error("Hata oluştu. Üzerinde işlem yapılan bir talepte işlem yapılamaz.", 1)
      bootstrap.Modal.getInstance(document.getElementById('sil_modal')).hide();
      this.grid?.load();
      this.siliniyor = false;
    });
  }

  silinecekTalep: KullaniciTalep | undefined;
  silinecekTalepNebis: NebisTalepBilgiler | undefined;


  silModal(talep: NebisTalepBilgiler) {
    // this.silinecekTalep = talep;
    this.silinecekTalepNebis = talep;

    
  }

  talepSayisiKontrol() {
    this.kullaniciTalepService.nebisAktifTalepList().subscribe(res=>{
      this.talepSay = res.data.length;
      if (this.talepSay > 2) {
        this.yetkiService.error("Hata ! Süreci devam eden en fazla 3 talep gönderebilirsiniz.", 1);
      }
      else {
        this.router.navigateByUrl('/talep-list/yeni')
      }
    });
  }
}
